var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12C15.6562 12 17 13.3438 17 15C17 16.6562 15.6562 18 14 18C12.3438 18 11 16.6562 11 15C11 14.7188 11.0312 14.4062 11.125 14.125L8.0625 12.1875C7.5 12.6875 6.78125 13 6 13C4.34375 13 3 11.6562 3 10C3 8.34375 4.34375 7 6 7C6.78125 7 7.5 7.3125 8.0625 7.84375L11.125 5.90625C11.0312 5.625 11 5.3125 11 5C11 3.34375 12.3438 2 14 2C15.6562 2 17 3.34375 17 5C17 6.65625 15.6562 8 14 8C13.1875 8 12.4688 7.6875 11.9062 7.1875L8.84375 9.125C9.03125 9.6875 9.03125 10.3438 8.84375 10.9062L11.9062 12.8438C12.4688 12.3125 13.1875 12 14 12ZM14 3.5C13.1562 3.5 12.5 4.1875 12.5 5C12.5 5.84375 13.1562 6.5 14 6.5C14.8125 6.5 15.5 5.84375 15.5 5C15.5 4.1875 14.8125 3.5 14 3.5ZM6 11.5C6.8125 11.5 7.5 10.8438 7.5 10C7.5 9.1875 6.8125 8.5 6 8.5C5.15625 8.5 4.5 9.1875 4.5 10C4.5 10.8438 5.15625 11.5 6 11.5ZM14 16.5C14.8125 16.5 15.5 15.8438 15.5 15C15.5 14.1875 14.8125 13.5 14 13.5C13.1562 13.5 12.5 14.1875 12.5 15C12.5 15.8438 13.1562 16.5 14 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.489da8ef264e539114e2714bd16ee7af.svg";
export { ForwardRef as ReactComponent };